import { useMemo } from "react";
import dayjs, { Dayjs } from "dayjs";

export function useParseDate(dateString: string) {
  const date = useMemo((): Dayjs => dayjs(dateString), [ dateString ]);
  return date;
}
